import { useState, useEffect } from 'react';

// Map country codes from API to our app country codes
const countryCodeMap = {
  'BO': 'BO', // Bolivia
  'PY': 'PY', // Paraguay
  'SV': 'SV'  // El Salvador
};

export const useCountryDetection = () => {
  const [detectedCountry, setDetectedCountry] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectCountry = async () => {
      // Check if country is already saved in localStorage
      const savedCountry = localStorage.getItem('userCountry');
      if (savedCountry) {
        setDetectedCountry(savedCountry);
        setIsLoading(false);
        return;
      }

      try {
        // Try to detect country using ipapi.co (free, no API key needed)
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        const countryCode = data.country_code;
        
        // Check if detected country is one of our supported countries
        if (countryCodeMap[countryCode]) {
          setDetectedCountry(countryCode);
          localStorage.setItem('userCountry', countryCode);
          console.log('✓ País detectado automáticamente:', countryCode);
        } else {
          // Country not supported, show modal
          setShowModal(true);
          console.log('✓ País no soportado, mostrando modal de selección');
        }
      } catch (error) {
        // If geolocation fails, show modal
        console.log('⚠ No se pudo detectar el país, mostrando modal');
        setShowModal(true);
      } finally {
        setIsLoading(false);
      }
    };

    detectCountry();
  }, []);

  const handleSelectCountry = (countryCode) => {
    localStorage.setItem('userCountry', countryCode);
    // Reload the page to apply the new country filter everywhere
    window.location.reload();
  };

  const clearCountry = () => {
    localStorage.removeItem('userCountry');
    setDetectedCountry(null);
    setShowModal(true);
  };

  return {
    detectedCountry,
    showModal,
    isLoading,
    handleSelectCountry,
    clearCountry
  };
};
